import { styled } from 'styled-components';
import { Media } from '../../../../../theme/Media.js';
export const PaginationWrapper = styled.div `
  background: ${({ theme }) => theme.colors.grey00_1};
  white-space: nowrap;
  padding: ${({ $compact }) => ($compact ? '8px 12px' : '16px 24px')};
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${Media.xsMax} {
    padding: 8px 12px;
    justify-content: space-between;

    & > :nth-child(1) {
      order: 2;
    }

    & > :nth-child(2) {
      order: 1;
    }

    & > :nth-child(3) {
      order: 3;
    }
  }
`;
export const PageInfoWrapper = styled.div `
  @media ${Media.smMin} {
    margin-left: auto;
  }
`;
